import { render } from "./DashboardSidebarLink.vue?vue&type=template&id=5a7c244f&scoped=true"
import script from "./DashboardSidebarLink.vue?vue&type=script&lang=js"
export * from "./DashboardSidebarLink.vue?vue&type=script&lang=js"

import "./DashboardSidebarLink.vue?vue&type=style&index=0&id=5a7c244f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7c244f"]])

export default __exports__